import React from "react";
import ContentfulMenus from "../../flexible/blocks/ContentfulMenus";
//import HomeBlocks from "../../routes/Home/HomeBlocks"

const blockTypes = {
  ContentfulMenus: ContentfulMenus,
};

const Home = ({ page }) => {
  //console.log("page: ", page)
  const blocks = [page.blocks];

  //   const JSX = blocks[page.blocks];
  return blocks.map((block, i) => {
    const { __typename } = block;
    const JSX = blockTypes[__typename];
    return JSX ? (
      <JSX key={"block" + i} block={block} slug={page.slug} />
    ) : (
      <div key={"block" + i}>ERROR {console.log(blockTypes[__typename])}</div>
    );
  });
};

export default Home;
